import React, { useRef } from "react";
import { StyleClass } from "primereact/styleclass";
import { Ripple } from "primereact/ripple";
import { useHistory } from "react-router-dom";
const NavBar = (props) => {
  const history = useHistory();
  const rootBtnRef = useRef(null);
  const btnRef1 = useRef(null);
  const refMenu1 = useRef(null);

  const clickHome = () => {
    history.push("/home");
  };

  const clickBagno = () => {
    refMenu1.current.classList.add("hidden");
    history.push("/bagno");
  };

  const clickCucina = () => {
    refMenu1.current.classList.add("hidden");
    history.push("/cucina");
  };

  const clickPortFolio = () => {
    refMenu1.current.classList.add("hidden");
    history.push("/portfolio");
  };

  const clickChiSiamo = () => {
    refMenu1.current.classList.add("hidden");
    history.push("/chisiamo");
  };

  return (
    <>
    <div className="surface-overlay py-2 px-6 shadow-2 flex align-items-center justify-content-between relative lg:static">
        <img
        src="/assets/logo/logo1_1.svg"
        alt="menediliziaristrutturazioni"
        width={150}
        height={150}
        onClick={clickHome}
        className="pt-2 cursor-pointer"
      />
      <StyleClass
        nodeRef={rootBtnRef}
        selector="@next"
        enterClassName="hidden"
        leaveToClassName="hidden"
        hideOnOutsideClick
      >
        <a ref={rootBtnRef} className="cursor-pointer block lg:hidden text-700">
          <i className="pi pi-bars text-4xl"></i>
        </a>
      </StyleClass>
      <div className="align-items-center surface-overlay flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full  left-0 top-100 px-6 lg:px-0 z-2 shadow-2 lg:shadow-none">
        <section></section>
        <ul className="list-none p-0 m-0  flex lg:align-items-center text-900 select-none flex-column lg:flex-row cursor-pointer">
        {props.home && 
                    <li>
                            <a
                                onClick={() => history.push("/home")}
                                className="p-ripple flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150"
                                >
                                <span>Home</span>
                                <Ripple />
                            </a>
                    </li>
                    }
          
          {props.openPreventivo && (
            <>
              <li className="relative">
                <StyleClass
                  nodeRef={btnRef1}
                  selector="@next"
                  enterClassName="hidden"
                  enterActiveClassName="scalein"
                  leaveToClassName="hidden"
                  leaveActiveClassName="fadeout"
                  hideOnOutsideClick
                >
                  <a
                    ref={btnRef1}
                    className="p-ripple flex px-0 lg:px-5 py-3 align-items-center hover:text-blue-600 font-medium transition-colors transition-duration-150 w-full"
                  >
                    <span>Ristrutturazioni</span>
                    <i className="pi pi-chevron-down ml-auto lg:ml-3"></i>
                    <Ripple />
                  </a>
                </StyleClass>
                <ul
                  className="list-none p-0 m-0 border-round shadow-0 lg:shadow-2 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem"
                  ref={refMenu1}
                >
                   
                  <li>
                    <a
                      onClick={() => props.openPreventivo("appartamento")}
                      className="p-ripple flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150 w-full"
                    >
                      <i className="pi pi-list text-2xl mr-2 text-blue-600"></i>
                      <span>Ristrutturazione appartamento</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => props.openPreventivo("casaindipendente")}
                      className="p-ripple flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150 w-full"
                    >
                      <i className="pi pi-shield text-2xl mr-2 text-blue-600"></i>
                      <span>Ristrutturazione casa indipendente</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={clickBagno}
                      className="p-ripple flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150 w-full"
                    >
                      <i className="pi pi-users text-2xl mr-2 text-blue-600"></i>
                      <span>Ristrutturazione bagno</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={clickCucina}
                      className="p-ripple flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150 w-full"
                    >
                      <i className="pi pi-users text-2xl mr-2 text-blue-600"></i>
                      <span>Ristrutturazione cucina</span>
                      <Ripple />
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  onClick={() => props.openPreventivo("appartamento")}
                  className="p-ripple flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150"
                >
                  <span>Genera preventivo</span>
                  <Ripple />
                </a>
              </li>

              <li>
                <a
                  onClick={clickPortFolio}
                  className="p-ripple flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150"
                >
                  <span>Portfolio</span>
                  <Ripple />
                </a>
              </li>
              <li>
                <a
                  onClick={clickChiSiamo}
                  className="p-ripple flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150"
                >
                  <span>Chi Siamo</span>
                  <Ripple />
                </a>
              </li>
              <li>
                <a
                  onClick={() => props.goToContatti()}
                  className="p-ripple flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150"
                >
                  <span>Contatti</span>
                  <Ripple />
                </a>
              </li>
            </>
          )}
        </ul>
        {/**
        <div className="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
            <Button label="Login" className="p-button-text font-bold" />
            <Button label="Register" className="ml-3 p-button-outlined font-bold" />
        </div>
        */}
      </div>
      
    </div>
    
  </>
  );
};
export default NavBar;
